<template>
  <div class="pageHeader">
    <div class="HomeContainer" style="display: flex; justify-content: space-between">
      <div class="leftContainer">
        <div>{{ l("欢迎来到中锻材") }}！</div>

        <template v-if="$store.state.session.token">
          <el-dropdown @command="handlePersonalCommand">
            <span style="cursor: pointer; font-size: 12px">


              <el-image v-if="$store.state.session.user.member_quotation_level" style="width:14px; height:14px;margin-right:4px;vertical-align: middle;" :src="GetResourceUrl('backend/SJT.svg')"></el-image>
              <el-image v-if="$store.state.session.user.member_purchase_level" style="width:14px; height:14px;margin-right:4px;vertical-align: middle;" :src="GetResourceUrl('backend/SCT.svg')"></el-image>

              {{ $store.state.session.user.display_name
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="setting">{{
                l("个人设置")
              }}</el-dropdown-item>
              <el-dropdown-item v-if="$store.state.session.host_token" key="logout_host" divided
                command="logout_host">{{ l("返回后管账号") }}</el-dropdown-item>
              <el-dropdown-item divided command="logout">{{
                l("退出登录")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <template v-else>
          <div class="btn" @click="$store.commit('logout')">
            {{ l("请登录") }}
          </div>
          <router-link class="btn" to="/register">{{
            l("免费注册")
          }}</router-link>
        </template>
      </div>
      <div class="rightContainer">
        <router-link class="link" to="/"> {{ l("中锻材首页") }} </router-link>
        <div class="split"></div>
        <template v-if="$store.state.session.token">
          <router-link class="link" to="/backend">{{
            l("个人中心")
          }}</router-link>
          <div class="split"></div>
        </template>
        <template v-if="$store.state.session.user.is_backend">
          <router-link class="link" to="/admin">{{
            l("后管系统")
          }}</router-link>
          <div class="split"></div>
        </template>
        <router-link class="link" to="/home/help">{{
          l("帮助中心")
        }}</router-link>
        <div class="split"></div>
        <!-- <div>{{ l("服务热线") }}：400-617-3617</div> -->
        <el-dropdown>
          <span class="el-dropdown-link" style="cursor: pointer;display: flex;align-items: center;">
            <svg t="1754976994821" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="6843" width="20" height="20">
              <path
                d="M848.805886 805.572222c70.998007-81.260745 109.779266-184.217628 109.779266-293.14448 0-119.204939-46.421262-231.277434-130.713041-315.569212C744.876861 113.862257 634.94103 67.61598 517.788843 66.213028c-1.924839-0.599657-10.290367-0.592494-12.227486 0.01535C388.878868 67.945485 279.434224 114.159016 196.73471 196.85853 113.863281 279.730982 67.630307 389.460106 66.095347 506.415818c-0.428765 1.64957-0.436952 8.601912-0.021489 10.226922 1.082658 117.628024 47.364751 228.058113 130.660852 311.354214 84.291778 84.291778 196.36325 130.713041 315.569212 130.713041 119.204939 0 231.277434-46.421262 315.569212-130.713041 6.139837-6.139837 12.054547-12.444427 17.789155-18.871813 0.50756-0.453325 1.001817-0.928139 1.471514-1.440815C847.750857 807.012014 848.295256 806.299793 848.805886 805.572222zM107.447151 532.043499l187.501418 0c1.322112 65.678862 9.253758 127.264499 22.505573 182.112688-61.690014 16.687054-100.819197 38.371936-121.076566 51.906184C144.30971 701.336206 111.676475 620.35687 107.447151 532.043499zM195.881272 259.408121c20.090571 13.556761 59.242266 35.461653 121.340579 52.260248-12.998035 54.127781-20.827351 114.778116-22.243607 179.432649L107.525945 491.101018C112.076588 403.731134 144.437623 323.612399 195.881272 259.408121zM917.081898 491.099994 729.628576 491.099994c-1.415232-64.630996-9.240455-125.260865-22.229281-179.37432 61.95505-16.693194 101.235682-38.444591 121.56673-52.020794C880.270505 323.860039 912.537396 403.866211 917.081898 491.099994zM688.677908 491.099994 532.167319 491.099994 532.167319 335.061149c52.209082-1.094938 97.103572-6.453992 135.272893-14.033621C680.000272 373.163955 687.286212 430.896844 688.677908 491.099994zM532.167319 294.115598 532.167319 109.918435c36.84107 10.398838 72.779583 49.205679 100.926644 110.015649 8.810666 19.035542 16.645099 39.641859 23.464411 61.521169C621.531626 288.227494 580.261687 293.062616 532.167319 294.115598zM491.223814 110.273523l0 183.805236c-47.504944-1.12666-88.378863-6.001691-123.120109-12.802584 6.807033-21.812795 14.623046-42.35976 23.409153-61.344137C419.351903 159.792333 454.809463 121.175827 491.223814 110.273523zM491.223814 335.040682l0 156.059312L335.928912 491.099994c1.391696-60.213383 8.679683-117.955482 21.243837-170.099073C395.008472 328.536548 439.487499 333.887416 491.223814 335.040682zM335.893096 532.043499l155.330718 0 0 158.667719c-51.609425 1.194198-96.019891 6.563486-133.821845 14.103206C344.576873 651.927913 337.193719 593.243349 335.893096 532.043499zM491.223814 731.672118l0 182.909843c-36.415374-10.902304-71.871911-49.51881-99.709933-109.659539-8.679683-18.752086-16.409738-39.034015-23.157419-60.551074C402.9964 737.645157 443.773106 732.820268 491.223814 731.672118zM532.167319 914.937049 532.167319 731.608673c47.904033 1.025353 89.103364 5.862521 124.116809 12.656251-6.755868 21.555945-14.497179 41.87369-23.190165 60.656475C604.946902 865.73137 569.008388 904.538211 532.167319 914.937049zM532.167319 690.660052 532.167319 532.043499l156.546406 0c-1.298576 61.096497-8.66024 119.68487-21.445428 172.502819C629.154233 697.013761 584.319096 691.710988 532.167319 690.660052zM729.659275 532.043499l187.501418 0c-4.221138 88.138386-36.732599 168.973436-88.620363 233.635131-20.469194-13.668301-59.635215-35.298947-121.30374-51.868321C720.43724 659.049101 728.33921 597.585237 729.659275 532.043499zM801.518906 228.742704c-18.329461 11.570523-52.309366 29.355585-104.858186 43.493583-19.295462-63.056128-46.110177-115.004267-78.06189-150.97655C689.00025 140.410913 751.833297 178.097234 801.518906 228.742704zM406.007991 121.259738c-31.905664 35.920094-58.690704 87.768973-77.979002 150.702304-52.40351-14.241352-86.370113-32.099069-104.581893-43.587728C273.076422 177.914062 335.777463 140.364865 406.007991 121.259738zM223.917816 796.963147c18.284435-11.535731 52.098565-29.230742 104.332207-43.335994 19.271926 62.60485 45.976124 114.186645 77.757968 149.968593C335.99952 884.550994 273.472442 847.181899 223.917816 796.963147zM618.59883 903.595746c31.801287-35.803437 58.517765-87.426165 77.792761-150.08218 51.984978 14.023388 85.972047 31.631418 104.533798 43.208081C751.3329 847.061149 688.718841 884.521319 618.59883 903.595746z"
                fill="#272636" p-id="6844"></path>
            </svg>
            <span style="margin-left:4px">
              {{ $store.state.lang === 'zh-CN' ? '中文（简体）' : 'English' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="selectLanguage('zh-CN')">中文（简体）</el-dropdown-item>
            <el-dropdown-item @click.native="selectLanguage('en-US')">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <PersonalInfo ref="PersonalInfo" @submitDialog="$store.dispatch('updateSession')" />
  </div>
</template>

<script>
import PersonalInfo from "@/views/account/PersonalInfo.vue";

export default {
  name: "PageHeader",
  components: {
    PersonalInfo,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    handlePersonalCommand(command) {
      if (command == "setting") {
        this.$refs.PersonalInfo.Type = "Edit";
        this.$refs.PersonalInfo.Show();
      } else if (command == "logout") {
        this.$store.commit("logout");
      } else if (command == "logout_host") {
        this.$localStorage.set("token", this.$store.state.session.host_token);
        this.$store.setSession("token", this.$store.state.session.host_token);

        this.$localStorage.remove("host_token");
        this.$localStorage.remove("host_token_admin");
        this.$store.setSession("host_token", null);
        this.$store.setSession("host_token_admin", null);

        setTimeout(() => {
          //保证在finally之后执行
          this.$store.dispatch("updateSession").then(() => {
            this.$store.commit("updateUnreadNotify");
            this.$router.push({ path: "/admin/dashboard" });
          });
        });
      }
    },
    selectLanguage(lang) {
      this.$localStorage.set("lang", lang);
      window.location.reload(); // 刷新页面以应用语言更改
    },
  },
};
</script>

<style scoped lang="scss">
.pageHeader {
  // background: #F1F1F1 ;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
  color: $themeColor;
  height: $topHeight;
  font-size: 12px;

  .leftContainer {
    height: $topHeight;
    display: flex;
    align-items: center;

    .btn {
      cursor: pointer;
      margin-left: 10px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .rightContainer {
    height: $topHeight;
    display: flex;
    align-items: center;

    .link {
      cursor: pointer;
    }

    .split {
      width: 1px;
      height: $topHeight / 3;
      background: #999;
      margin: 0 12px;
    }
  }
}

// a标签(router-link样式)
a {
  color: $themeColor;
}
</style>
